import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "form-label"
}, "Nombre de Usuario:", -1)
const _hoisted_5 = {
  id: "username",
  class: "p-inputtext form-control disabled-field"
}
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "zona",
  class: "form-label"
}, "Perfil:", -1)
const _hoisted_9 = { class: "row mt-5" }
const _hoisted_10 = { class: "col-md-12 text-center" }

export function render(_ctx, _cache) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("form", {
    autocomplete: "off",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.updateUser()), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.usuario.user), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Dropdown, {
            id: "zona",
            class: "vue-input",
            options: _ctx.zonas,
            optionLabel: "valor",
            name: "select1",
            optionValue: "id",
            placeholder: "Seleccionar...",
            modelValue: _ctx.usuario.perfil,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.usuario.perfil) = $event)),
            requiered: ""
          }, null, 8, ["options", "modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Button, {
          type: "submit",
          label: "Actualizar",
          severity: "success",
          loading: _ctx.loader,
          icon: "pi pi-save"
        }, null, 8, ["loading"])
      ])
    ])
  ], 32))
}